import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableBoolean, nullableNumber, nullableString } from '../utils/wire-value-utils';

/**
 * A support ticket attachment. Built from the hub's `SupportTicketAttachmentResponse`
 * (`GET /support-tickets/:id/attachments`), which adds display fields (`formattedFileSize`, `isImage`,
 * `isPdf`, `fileIcon`). The upload response sends the raw row, so those stay `undefined` there.
 */
export class SupportTicketAttachment extends Base {
  ticketId?: string | null;
  fileName?: string | null;
  fileSize?: number | null;
  formattedFileSize?: string | null;
  fileType?: string | null;
  fileExtension?: string | null;
  downloadUrl?: string | null;
  previewUrl?: string | null;
  uploadedByName?: string | null;
  uploadedByEmail?: string | null;
  uploadedAt?: string | null;
  isImage?: boolean | null;
  isPdf?: boolean | null;
  fileIcon?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.ticketId = nullableString(source['ticketId']);
    this.fileName = nullableString(source['fileName']);
    this.fileSize = nullableNumber(source['fileSize']);
    this.formattedFileSize = nullableString(source['formattedFileSize']);
    this.fileType = nullableString(source['fileType']);
    this.fileExtension = nullableString(source['fileExtension']);
    this.downloadUrl = nullableString(source['downloadUrl']);
    this.previewUrl = nullableString(source['previewUrl']);
    this.uploadedByName = nullableString(source['uploadedByName']);
    this.uploadedByEmail = nullableString(source['uploadedByEmail']);
    this.uploadedAt = nullableString(source['uploadedAt']);
    this.isImage = nullableBoolean(source['isImage']);
    this.isPdf = nullableBoolean(source['isPdf']);
    this.fileIcon = nullableString(source['fileIcon']);
  }
}
